import clsx from "clsx";
import React, { Fragment, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Button from "../../../../../../common/Button";
import Title from "../../../../../learning/presentational/body/view/directive/Title";
import Tip from "./tip/Tip";
import WrongAnswerTip from "./tip/WrongAnswerTip";

const Directive = (props) => {

  const [isWrongAnswerTip, setIsWrongAnswerTip] = useState(false);
  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const questionView = useSelector(state => state.questionView);
  const params = useParams();

  const {
    QuestionTipHider,
    ScribbleCleaner,
    ScribbleErase
  } = props;

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    setIsWrongAnswerTip(!isWrongAnswerTip);
  }, [isWrongAnswerTip])

  return (
    <div className="learning_head">
      <div className="mathQuest-wrap">
        <Title>{answeringQuestions.data.textCn}</Title>
        {answeringQuestions.data.exmpCn && <QuestionTipHider><Tip /></QuestionTipHider>}
        {answeringQuestions.isShowKeypad && <Button className="note_btn">연습장</Button>}
        {
          (params?.testApp === 'inspect' && answeringQuestions.data.explCn) && (
            <>
              <Button
                style={{ width: 80, marginLeft: 10 }}
                className={clsx('btn_epn', 'btn-viewopen', 'on')}
                onClick={handleClick}
              >
                풀이보기
              </Button>
              {isWrongAnswerTip && <WrongAnswerTip onClose={handleClick}>{answeringQuestions.data.explCn}</WrongAnswerTip>}
            </>
          )
        }
      </div>
      
      {
        !answeringQuestions.isShowKeypad && questionView.isScribble && (
          <div className="btn_wrap scratch">
            <ScribbleErase>
              <Buttons />
            </ScribbleErase>
          </div>
        )
      }
      <ScribbleCleaner>{!answeringQuestions.isShowKeypad && questionView.isScribble && <Button className="btn-learning-del on">삭제</Button>}</ScribbleCleaner>
    </div>
  );

};

const Buttons = (props) => {
  const questionView = useSelector(state => state.questionView);
  return (
    <div className="pos_rgt">
      <button
        type="button"
        className={clsx(
          "bg_ple wht pen",
          questionView.isErase ? 'off' : 'on'
        )}
        onClick={() => props.handleEraseClick(false)}
      />
      <button
        type="button"
        className={clsx(
          "bg_ple wht eraser",
          questionView.isErase ? 'on' : 'off'
        )}
        onClick={() => props.handleEraseClick(true)} />
      <button
        type="button"
        className="bg_ple wht prev off"
        onClick={props.handleUndoClick}
      />
      {/* <button type="button" className="bg_ple wht next off"></button> */}
    </div>
  )
}

Directive.defaultProps = {
  QuestionTipHider: Fragment,
  ScribbleCleaner: Fragment,
  ScribbleErase: Fragment
};

export default Directive;
